import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  AdministrationOverviewDto,
  RoleSummaryDto,
  RoleUpsertRequest,
  UserSummaryDto,
  UserUpsertRequest
} from '../models/admin.model';

@Injectable({ providedIn: 'root' })
export class AdministrationService {
  private readonly api = inject(ApiService);

  getOverview(): Observable<AdministrationOverviewDto> {
    return this.api.get<AdministrationOverviewDto>('/admin/overview');
  }

  createRole(request: RoleUpsertRequest): Observable<RoleSummaryDto> {
    return this.api.post<RoleSummaryDto>('/admin/roles', request);
  }

  updateRole(id: number, request: RoleUpsertRequest): Observable<RoleSummaryDto> {
    return this.api.put<RoleSummaryDto>(`/admin/roles/${id}`, request);
  }

  createUser(request: UserUpsertRequest): Observable<UserSummaryDto> {
    return this.api.post<UserSummaryDto>('/admin/users', request);
  }

  updateUser(id: number, request: UserUpsertRequest): Observable<UserSummaryDto> {
    return this.api.put<UserSummaryDto>(`/admin/users/${id}`, request);
  }
}
